export const BASE_FULFILLMENT_PATH = `/fulfillment`;
